import { turboproApiLista } from '@/api/turbopro';
import type { BuscarTiposAgendamentosResponse, TipoAgendamentoApi } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function buscarTiposAgendamentosApi(): Promise<BuscarTiposAgendamentosResponse> {
  const resposta = await turboproApiLista<TipoAgendamentoApi>(
    'Relatorios/BuscarTiposAgendamentos',
    { headers: getRelatoriosHeaders() }
  );
  return resposta.data ?? [];
}
